import { Shield, AlertTriangle, AlertCircle, Info, Check } from 'lucide-react';

export const OPERATORS = [
  { value: '==', label: 'Égal à (==)', symbol: '=' },
  { value: '!=', label: 'Différent de (!=)', symbol: '≠' },
  { value: '>', label: 'Supérieur à (>)', symbol: '>' },
  { value: '<', label: 'Inférieur à (<)', symbol: '<' },
  { value: '>=', label: 'Supérieur ou égal (≥)', symbol: '≥' },
  { value: '<=', label: 'Inférieur ou égal (≤)', symbol: '≤' },
  { value: 'in', label: 'Dans la liste', symbol: '∈' },
  { value: 'not_in', label: 'Pas dans la liste', symbol: '∉' }
];

export const ACTIONS = [
  { value: 'block', label: 'Bloquer', icon: Shield, color: 'text-red-600', bg: 'bg-red-50' },
  { value: 'cap', label: 'Plafonner', icon: AlertTriangle, color: 'text-yellow-600', bg: 'bg-yellow-50' },
  { value: 'require_validation', label: 'Exiger validation', icon: AlertCircle, color: 'text-purple-600', bg: 'bg-purple-50' },
  { value: 'warning', label: 'Avertissement', icon: Info, color: 'text-blue-600', bg: 'bg-blue-50' },
  { value: 'set_value', label: 'Définir valeur', icon: Check, color: 'text-green-600', bg: 'bg-green-50' }
];

export const SEVERITIES = [
  { value: 'hard', label: 'HARD', description: 'Blocage total', color: 'bg-red-500', icon: '🛑' },
  { value: 'soft', label: 'SOFT', description: 'Ajustement', color: 'bg-yellow-500', icon: '⚠️' },
  { value: 'ess', label: 'ESS', description: 'Validation coop', color: 'bg-purple-500', icon: '🤝' },
  { value: 'warning', label: 'WARNING', description: 'Information', color: 'bg-blue-500', icon: '💡' }
];

export const DEFAULT_VARIABLES = [
  { key: 'type_acteur', label: 'Type d\'acteur', type: 'string', values: ['Particulier', 'TPE', 'Exploitant', 'Association'] },
  { key: 'territoire', label: 'Territoire', type: 'string', values: ['Guadeloupe', 'Martinique', 'Guyane', 'France Hexagonale', 'GCC', 'UAE'] },
  { key: 'secteur', label: 'Secteur', type: 'string', values: ['Habitat', 'BTP', 'Agriculture', 'Commerce', 'Formation'] },
  { key: 'revenu_mensuel', label: 'Revenu mensuel (€)', type: 'number' },
  { key: 'chiffre_affaires', label: 'Chiffre d\'affaires (€)', type: 'number' },
  { key: 'montant_projet', label: 'Montant projet (€)', type: 'number' },
  { key: 'apport', label: 'Apport personnel (€)', type: 'number' },
  { key: 'duree_mois', label: 'Durée (mois)', type: 'number' },
  { key: 'effort_financier', label: 'Effort financier (ratio)', type: 'number' }
];
